import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '#src/cn.ts'

export const TableRow = forwardRef<
  HTMLTableRowElement,
  HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
  <tr
    ref={ref}
    className={cn(
      'border-b transition-colors hover:bg-muted/50 data-[selected=true]:bg-muted data-[state=open]:bg-muted/50',
      className
    )}
    {...props}
  />
))
TableRow.displayName = 'TableRow'
